export enum ColumnOptionsLabels {
  Create = 'Create',
  Update = 'Update',
  Cancel = 'Cancel',
  Apply = 'Apply',
  Reset = 'Reset',
  BackToOptions = 'BackToOptions',
}
